import PrivacyPoliciesAndTermsAndConditions from './PrivacyPoliciesAndTermsAndConditions';

export default PrivacyPoliciesAndTermsAndConditions;
